import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from '@mui/material/colors';

export enum ColorDerivationStrategy {
  FIRST_CHAR,
  MIDDLE_CHAR,
}

const colors = [
  amber,
  blue,
  blueGrey,
  brown,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
];

type MuiColorWithShades = (typeof colors)[number];

const generateColorForName = (
  name: string,
  strategy: ColorDerivationStrategy,
): MuiColorWithShades => {
  if (strategy === ColorDerivationStrategy.FIRST_CHAR) {
    const charCode = name.charCodeAt(0).toString();
    const charColorIndex = Number(charCode[charCode.length - 1]);

    const colorIndex = Math.floor((charColorIndex / 10) * colors.length);

    return colors[colorIndex];
  }

  let hash = 5381;

  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) + hash + name.charCodeAt(i)) >>> 0;
  }

  const colorIndex = hash % colors.length;

  return colors[colorIndex];
};

export default generateColorForName;
